// Centralised flag for the Amazon SP-API OAuth quota outage (case 20428167541).
// Flip AMAZON_MAINTENANCE_MODE to false once Amazon raises the cap and new connections work.
// When flipped off, all maintenance gates throughout the app deactivate.

export const AMAZON_MAINTENANCE_MODE = true;

export const AMAZON_MAINTENANCE_TITLE = 'Amazon Integrations Under Maintenance';

export const AMAZON_MAINTENANCE_MESSAGE =
  "Amazon integrations are temporarily under maintenance. We'll notify you once they're back online.";
